export enum QueryKey {
  Team = 'team',
  User = 'user',
  Tag = 'tag',
  Badge = 'badge',
}
